import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'

import { fetchConfiguration } from '../../actions/configurationActions'
import { selectConfiguration } from '../../reducers/configurationReducer'
import Breadcrumb from '../../components/Breadcrumb'
import LoadingSection from '../../components/loadingSection'
import { Configuration } from '../../core/types'

interface RouteParams {
  id: string
}

interface LocationState {
  versions?: any[]
  callCenterName?: string
}

const ConfigurationLog = () => {
  const dispatch = useDispatch()
  const { id } = useParams<RouteParams>()
  const location = useLocation<LocationState>()

  useEffect(() => {
    if (!location.state?.versions) {
      dispatch(fetchConfiguration(id))
    }
  }, [dispatch, id, location.state])

  const configuration: Configuration | undefined = useSelector((state: any) =>
    selectConfiguration(state.configurations, id)
  )

  const versions = location.state?.versions ?? configuration?.versions ?? []
  const callCenterName =
    location.state?.callCenterName ?? configuration?.callCenterName

  const loading = !versions.length && !configuration

  const levels = [
    { label: 'Index', path: '/' },
    { label: 'Configuration', path: '/configuration' },
    {
      label: callCenterName,
      path: `/configuration/${id}`,
    },
  ]

  return (
    <>
      <Breadcrumb levels={levels} />
      <LoadingSection isLoading={loading}>
        <div className="index index__drive-america">
          <h1 className="index-table__header">Configuration Logs</h1>

          {versions.length === 0 ? (
            <div className="empty-text">
              No configuration logs available.
            </div>
          ) : (
            <table className="index-table">
              <thead>
                <tr className="index-table__row">
                  <th className="index-table__cell">Event</th>
                  <th className="index-table__cell">Whodunnit</th>
                  <th className="index-table__cell">Ip Address</th>
                  <th className="index-table__cell">Source</th>
                  <th className="index-table__cell">Date</th>
                  <th className="index-table__cell">Changes</th>
                </tr>
              </thead>
              <tbody className="index-table__body">
                {versions.map((version: any) => (
                  <tr key={version.id} className="index-table__row">
                    <td className="index-table__cell">
                      {version.event}
                    </td>
                    <td className="index-table__cell">
                      {version.whodunnit}
                    </td>
                    <td className="index-table__cell">
                      {version.ipAddress}
                    </td>
                    <td className="index-table__cell">
                      {version.source}
                    </td>
                    <td className="index-table__cell">
                      {new Date(version.createdAt).toLocaleString()}
                    </td>
                    <td className="index-table__cell">
                      <details>
                        <summary>View</summary>
                        <pre>
                          {JSON.stringify(
                            version.objectChanges,
                            null,
                            2
                          )}
                        </pre>
                      </details>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </LoadingSection>
    </>
  )
}

export default ConfigurationLog